<template>
  <div class="news-square" >
    <div class="sim-filler" v-on:click="handleClick">
      <router-link :to="permalink"><img :src="tileImageUrl" class="news-tile" :alt="item.alt" /></router-link>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    item: Object,
    artist: Object
  },
  computed: {
    permalink () {
      if(this.item.url) {
        return this.$k.getImagePermalink(this.item, this.artist)
      }
      return ''
    },
    tileImageUrl: function () {
      let timage = this.item.url
      if(timage){
        timage = this.$k.forceFileExtension(timage, '.jpg')
        return this.$k.getImageCrop500(timage)
      }
      return this.$k.randomBlurry()
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
}
</script>

<style>
.sim-filler{
  width:100%;
  padding-bottom:100%;
  z-index:0;
  overflow:hidden;
}

</style>